import { createRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { AuthLayout } from '@/components/layout/auth-layout.js';
import { ForgotPasswordForm } from '@/features/auth/forgot-password-form.js';
import { rootRoute } from './root.js';

function ForgotPasswordPage(): JSX.Element {
  return (
    <AuthLayout title="Mot de passe oublié" description="Recevez un lien de réinitialisation par email.">
      <ForgotPasswordForm />
    </AuthLayout>
  );
}

/** `/mot-de-passe-oublie` — `02` §1. */
export const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/mot-de-passe-oublie',
  component: ForgotPasswordPage,
});
